import axios from "axios";

export default function getShippingOrderList(parameters) {
  return new Promise((resolve, reject) => {
    axios
      .post("/distributor/admin/api/v1/shipping-order/list", {
        length: parameters.length,
        start: parameters.start,
        filter: {
          search: parameters.filter.search,
          search_column: parameters.filter.search_column,
          requestor: parameters.filter.requestors,
          products: parameters.filter.products,
          status: parameters.filter.status,
          receiver_country: parameters.filter.receiver_country,
        },
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
